import React from 'react';
import { Trans } from 'react-i18next';
import backgroundImage from '../../Assets/Images/Placeholders/usc_signin.jpg';
import { CopyrightFooter, LanguageSelector } from '../../Components';
import { WHITE } from '../../Constants/Colors.constants';
import { makeStyles } from '~/UIKit/Style';
import { LoginCustomHeader } from './components/';
import LoginForm from './components/LoginForm';
import { useLogin } from './useLogin';

const useStyles = makeStyles((theme) => ({
  rootLoginUSC: {
    overflow: 'overlay',
    maxHeight: '100vh',
    minWidth: 320,
    backgroundColor: WHITE,
  },
  containerLoginUSC: {
    display: 'flex',
    flexDirection: 'row-reverse',
    height: 'calc(100vh - 70px)',
    position: 'relative',
    fontWeight: 300,
    fontSize: '13px',
    backgroundColor: WHITE,
    [theme.breakpoints.down('md')]: {
      display: 'block',
      height: 'calc(100vh + 125px)',
    },
  },
  contentLoginUSC: {
    flex: 1,
    margin: 'auto',
    [theme.breakpoints.down('md')]: {
      padding: '0 20px',
      marginTop: 30,
    },
  },
  sideLoginUSC: {
    flex: 1,
    backgroundImage: `url('${backgroundImage}')`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-end',
    [theme.breakpoints.down('md')]: {
      height: '100%',
    },
  },
  textLoginUSC: {
    fontWeight: 700,
    fontSize: 80,
    lineHeight: '80px',
    textAlign: 'center',
    color: WHITE,
    marginBottom: 60,
    [theme.breakpoints.down('md')]: {
      fontSize: 60,
      lineHeight: '60px',
    },
  },
  languageWrapperLoginUSC: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: 30,
  },
}));

export const LoginUSC = () => {
  const { error, onLoginFormSubmit, t, isLoginLoading } = useLogin();
  const { classes } = useStyles();
  return (
    <div className={classes.rootLoginUSC}>
      <LoginCustomHeader />
      <div className={classes.containerLoginUSC}>
        <div className={classes.contentLoginUSC}>
          <LoginForm
            hasSignUp={false}
            isLoading={isLoginLoading}
            onSubmit={onLoginFormSubmit}
            isUsingThePartnerTool
            t={t}
            error={error}
          />
          <div className={classes.languageWrapperLoginUSC}>
            <LanguageSelector />
          </div>
          <CopyrightFooter isUsingThePartnerTool />
        </div>
        <div className={classes.sideLoginUSC}>
          <div className={classes.textLoginUSC}>
            <Trans i18nKey="login.usc.signIn" />
          </div>
        </div>
      </div>
    </div>
  );
};
